import { Heading, Paragraph } from "@digdir/designsystemet-react";
import "./AreaDescription.css";

export const AreaDescription: React.FC<{
    children?: React.ReactNode;
    heading: string;
    live?: boolean;
    text?: string;
}> = ({ children, heading, live, text }) => {
    return (
        <div className="area-description" role={live ? "status" : undefined}>
            <div className="area-description__text">
                <Heading level={3} data-size="sm">
                    {heading}
                </Heading>
                {text && (
                    <Paragraph data-size="md" style={{ whiteSpace: "pre-line" }}>
                        {text}
                    </Paragraph>
                )}
            </div>

            {children}
        </div>
    );
};
